module.exports = __webpack_public_path__ + "pc/img/rec_17.c4d02640.svg";